export class Pattern {
  static readonly EMAIL_VALIDATOR: RegExp = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,}$/i;
  static readonly NAME_VALIDATOR: RegExp = /^(?=\S)(?=.*\S$)(?!.* {2})[- a-zA-Z'`’\u00C0-\u00FF]*$/;
  static readonly TRADING_PASSWORD_VALIDATOR: RegExp = /^\d{4}$/;
}
